import {useLogout} from '../customHooks/useLogout';
import {useEffect, useContext} from 'react';
import {IntlContext} from '../containers/IntlProvider';

/**
 * Renders logged out message
 * @return {JSX.Element}
 */
export const LoggedOut = () => {
  const {mutate: logout} = useLogout();
  const localizedStringBundle: StringMap = useContext(IntlContext);

  useEffect(() => {
    logout();
  }, []);

  return (
    <div className="h-screen w-full bg-surface pt-8 text-center">
      <div className="reimagine-text-body1 pb-8 text-lg">{localizedStringBundle.LOGGED_OUT}</div>
    </div>
  );
};
